import React, { useEffect } from 'react'
import { Modal, Button } from '@imedcl/design-system'
import { ReactComponent as Imagedisconnected } from '../../assets/img/disconnected_medpay.svg'
import { useNavigate } from 'react-router-dom'
import { clearStorage } from '../../hooks/clearStorage'

export default function ModalContent() {
  const navigate = useNavigate()
  const { clear } = clearStorage()

  useEffect(() => {
    let sessionActive = localStorage.getItem('session')
    if (!sessionActive) {
      window.setTimeout(function () {
        navigate('/')
      }, 10000) // tiempo en milisegundo.
    }
    //Liamos las variables de sesión.
    clear()
  })

  const volver = () => {
    navigate('/')
  }

  return (
    <div className='mt-8'>
      <Modal backgroundClassName='!relative'>
        <React.Fragment key='.0'>
          <div className='mb-6  flex items-center justify-center '>
            <Imagedisconnected></Imagedisconnected>
          </div>
          <div>
            <h1 className='text-center font-bold text-2xl text-secondary-imed-100 mb-4'>
              Conexión fallida
            </h1>
          </div>
          <div>
            <h2 className='text-center text-xl text-secondary-imed-100 mb-4'>
              No podemos conectar con el sistema en este momento, intente más
              tarde.
            </h2>
          </div>
          <div className='flex items-center justify-center'>
            <Button className='m-4 ' type='secondary' onClick={volver}>
              Volver
            </Button>
          </div>
        </React.Fragment>
      </Modal>
    </div>
  )
}
